import { JobReadinessStatus } from './JobReadinessStatus';

/**
 * One labor line a readiness check points at (US 37167, the Labor check):
 * which line, on which timesheet, and why it needs attention.
 */
export interface JobReadinessItemDto {
  /** Red: the export will hold or fail the line. Warn: worth checking, may be intended. */
  Status: JobReadinessStatus;
  /** Why the line needs attention. */
  Label: string;
  EmployeeLaborID: string;
  TimeSheetID: string | null;
  TimeSheetName: string | null;
  Employee: string | null;
  DateWorked: string | Date | null;
  Hours: number | null;
  /** True when the line was already exported, so a fix goes through Reallocate. */
  Exported: boolean;
}
